module.exports = __webpack_public_path__ + "img/Twitter_Social_Icon_Circle_Color.2d8eb5e3.svg";